import React, { useEffect, useRef } from 'react';

const DinosaurGame = () => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const gameKeys = ['ArrowUp', 'ArrowDown', 'Space', ' '];

    const focusGame = () => {
      try {
        iframe.contentWindow && iframe.contentWindow.focus();
      } catch (e) {
        // cross-origin u otro error: lo ignoramos
      }
    };

    // 1) Cuando termina de cargar el iframe, le damos foco
    //    así el juego responde a Space/Arrows sin que el usuario tenga que clickear
    iframe.addEventListener('load', focusGame);

    // 2) Si el iframe entra en viewport, también le damos foco
    //    (cubre el caso de que el usuario navegue por scroll hasta el juego)
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) focusGame();
        });
      },
      { threshold: 0.5 }
    );
    io.observe(iframe);

    // 3) Si el usuario apreta una tecla del juego estando fuera del iframe,
    //    le damos el foco y prevenimos el scroll default. La próxima tecla ya
    //    llega al iframe y el juego responde normalmente.
    const handleParentKeydown = (event) => {
      const key = event.key;
      const isGameKey = gameKeys.includes(key) || event.code === 'Space';
      if (!isGameKey) return;

      // Si el iframe está en viewport, asumimos que el usuario quiere jugar
      const rect = iframe.getBoundingClientRect();
      const inView =
        rect.top < window.innerHeight && rect.bottom > 0;
      if (!inView) return;

      event.preventDefault();
      focusGame();
    };

    window.addEventListener('keydown', handleParentKeydown);

    return () => {
      iframe.removeEventListener('load', focusGame);
      window.removeEventListener('keydown', handleParentKeydown);
      io.disconnect();
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      className="dinoSaur"
      src="/dinosaur-game/index.html"
      width="800"
      height="400"
      style={{ border: 'none' }}
      title="Dinosaur Game"
      tabIndex="0"
    ></iframe>
  );
};

export default DinosaurGame;
